// src/utils/roleHelper.js
export const getRoleFromRoleId = (roleId) => {
  const roleMap = {
    1: "Administrateur",
    2: "Demo",
    3: "TournoiPro",
    4: "TournoiUltim",
  };
  return roleMap[roleId] || "user"; // Fallback à 'user' si `roleId` est inconnu
};
